/* eslint-disable no-debugger */
import { AxiosResponse } from "axios";

import { ICreateNoteProps, IEditNoteProps } from "../@types/Note";
import { IPaginatedResponse } from "../@types/PaginatedResponse";
import { api } from "./api";

export const noteService = {
  async getNotes(patientId: number): Promise<AxiosResponse> {
    const url = "/Portal/Notes";

    const urlParamsParsed = new URLSearchParams();

    urlParamsParsed.append("patientId", patientId.toString());

    const notesResponse = await api.get<IPaginatedResponse<any>>(url, {
      params: urlParamsParsed,
    });

    return notesResponse;
  },

  async getNotesPaginated(
    patientId: number,
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Notes";

    const params: Record<string, string | number> = {
      patientId,
    };

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }

    return api.get<IPaginatedResponse<any>>(url, { params });
  },

  async getNoteById(id: number): Promise<AxiosResponse> {
    const url = `/Portal/Notes/${id}`;
    const note = await api.get(url);
    return note;
  },

  async createNote(createNoteProps: ICreateNoteProps): Promise<AxiosResponse> {
    const url = `/Portal/Notes/`;
    const time = new Date().toISOString();
    const { noteContent, patientId, taggedHcpIds, assignedHcpId, isUrgent } =
      createNoteProps;

    const response = await api.post(url, {
      time,
      noteContent,
      patientId,
      taggedHcpIds,
      assignedHcpId: assignedHcpId ?? null,
      isUrgent: isUrgent ?? false,
    });
    return response;
  },

  async editNote(
    id: number,
    editNoteProps: IEditNoteProps
  ): Promise<AxiosResponse> {
    const url = `/Portal/Notes/${id}`;
    const { noteContent, taggedHcpIds, assignedHcpId, isUrgent } =
      editNoteProps;

    const response = await api.put(url, {
      noteContent,
      taggedHcpIds,
      assignedHcpId: assignedHcpId ?? null,
      isUrgent: isUrgent ?? false,
    });
    return response;
  },

  async deleteNote(id: number): Promise<AxiosResponse> {
    const url = `/Portal/Notes/${id}`;

    const response = await api.patch(url, { publish: false });
    return response;
  },

  async setUrgent(id: number, isUrgent: boolean): Promise<AxiosResponse> {
    const url = `/Portal/Notes/${id}/Urgent`;
    return api.patch(url, { isUrgent });
  },

  async setCompleted(id: number, isCompleted: boolean): Promise<AxiosResponse> {
    const url = `/Portal/Notes/${id}/Complete`;
    return api.patch(url, { isCompleted });
  },

  async getMyAssignedTasks(
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Notes/MyTasks";

    const params: Record<string, string | number> = {};
    if (page !== undefined) params.page = page;
    if (pageSize !== undefined) params.pageSize = pageSize;

    return api.get<IPaginatedResponse<any>>(url, { params });
  },
};
